import {
  gcIconColors,
  gcIconNames,
  gcTextColors,
} from '@ip-only/front-end-library';
import { StatusStyle } from './status-style.entities';
import { createBasicStatusStyle } from './status-style.helper';

export const activeBasicStatusStyle: StatusStyle = createBasicStatusStyle(
  gcIconColors.active,
);

export const cautionBasicStatusStyle: StatusStyle = createBasicStatusStyle(
  gcIconColors.caution,
);

export const criticalBasicStatusStyle: StatusStyle = createBasicStatusStyle(
  gcIconColors['critical-strong'],
);

export const inactiveStatusStyle: StatusStyle = {
  icon: { name: gcIconNames.circleClose, color: gcIconColors.secondary },
  textColor: gcTextColors.secondary,
};

/** SDU planned icon (clock) with active (blue) for in-progress sections */
export const inProgressStatusStyle: StatusStyle = {
  icon: { name: gcIconNames.clock, color: gcIconColors.active },
  textColor: gcTextColors.primary,
};

export const successStatusStyle: StatusStyle = {
  icon: { name: gcIconNames.circleCheck, color: gcIconColors.success },
  textColor: gcTextColors.success,
};

export const successStrikeThroughStatusStyle: StatusStyle = {
  icon: { name: gcIconNames.circleStrikeThrough, color: gcIconColors.success },
  textColor: gcTextColors.success,
};

export const pendingStatusStyle: StatusStyle = {
  icon: { name: gcIconNames.clock, color: gcIconColors.caution },
  textColor: gcTextColors.caution,
};

export const criticalStatusStyle: StatusStyle = {
  icon: { name: gcIconNames.triangleExclamation, color: gcIconColors.critical },
  textColor: gcTextColors.critical,
};

export const defaultStatusStyle: StatusStyle = {
  textColor: 'secondary',
};
